import { ActionReducer, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

const localStorageSyncReducer = (reducer: ActionReducer<any>): ActionReducer<any> =>
  localStorageSync({
    keys: ['core'],
    // keys: [
    //   {
    //     core: ['user', 'token', 'sidenavOpened', 'appVersion', 'isCookieAccepted', 'consentForms'],
    //   }
    // ],
    syncCondition: () => true,
    rehydrate: true,
  })(reducer);

export const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer];
